"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const MiddlewareException_1 = tslib_1.__importDefault(require("../../models/Exceptions/MiddlewareException"));
const jwt_1 = tslib_1.__importDefault(require("../../tools/jwt"));
function guest(to, from, next) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        console.group('guest');
        if (to.meta.guest) {
            jwt_1.default.clear();
            console.log('Guest route, disrupting.');
            console.groupEnd();
            throw new MiddlewareException_1.default();
        }
        console.log('Not a guest route, proceeding.');
        console.groupEnd();
        return next && next.call ? next() : next;
    });
}
exports.default = guest;
//# sourceMappingURL=guest.js.map